import React from 'react'
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'

import { hooks } from './hooks'

import { storeStatusStatusOpts as SSSOpts } from '../constants'
import useCStyles from './MultiStoreNotification.styles'

import type {
  MultiStoreNotificationItemProps as ItemProps,
  MultiStoreNotificationProps as ListProps,
} from '../types'

// +++++ MultiStoreNotification
export function MultiStoreNotification(props: ListProps): JSX.Element {
  const { stores } = props
  return (
    <List aria-roledescription='multi-store notification list'>
      {stores.map(item => (
        <MultiStoreNotificationItem
          key={`stores-on-${item.state}`}
          total={item.total}
          state={item.state}
        />
      ))}
    </List>
  )
}
// ----- MultiStoreNotification

// +++++ StoreStatusNotificationItem
export function MultiStoreNotificationItem(props: ItemProps): JSX.Element {
  const { total, state = SSSOpts.SUSPENDED.status } = props

  const TheIcon = SSSOpts[state]?.elementIcon ?? 'div'

  const classes = useCStyles({ state })
  const texts = hooks.useTexts({ state, total })

  return (
    <ListItem classes={{ root: classes.listItem }}>
      <ListItemIcon classes={{ root: classes.itemIcon }}>
        <TheIcon
          role='img'
          classes={{ root: classes.icon }}
          alt={`icon-${state.toLowerCase()}`}
        />
      </ListItemIcon>
      <ListItemText
        role='note'
        primary={texts.pluralState}
        secondary={`${total} ${texts.storeName}`}
        classes={{
          root: classes.rootText,
          primary: classes.primaryText,
          secondary: classes.secondaryText,
        }}
      ></ListItemText>
    </ListItem>
  )
}
// ----- StoreStatusNotificationItem
